import React from 'react';
import { Box, Typography, Paper, Button, TextField } from '@mui/material';
import { Update } from '@mui/icons-material';
import { Role } from '../types/roles';

interface RoleFormProps {
  selectedRole: Role | null;
  roleName: string;
  setRoleName: (name: string) => void;
  roleDescription: string;
  setRoleDescription: (description: string) => void;
  onUpdate: () => void;
}

const RoleForm: React.FC<RoleFormProps> = ({
  selectedRole,
  roleName,
  setRoleName,
  roleDescription,
  setRoleDescription,
  onUpdate,
}) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Name
        </Typography>
        <TextField
          fullWidth
          label="Role Name"
          size="small"
          placeholder="Role Name"
          value={roleName}
          onChange={(e) => setRoleName(e.target.value)}
          sx={{ bgcolor: (theme) => theme.palette.custom.textFieldBackground }}
        />
      </Box>
      <Box>
        <Typography variant="subtitle1" gutterBottom>
          Description
        </Typography>
        <TextField
          fullWidth
          size="small"
          label="Role Description"
          placeholder="Role Description"
          value={roleDescription}
          onChange={(e) => setRoleDescription(e.target.value)}
          sx={{ bgcolor: (theme) => theme.palette.custom.textFieldBackground }}
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onUpdate}
          disabled={!selectedRole}
          startIcon={<Update />}
          sx={{ textTransform: 'uppercase', bgcolor: (theme) => theme.palette.custom.buttonBackground }}
        >
          Update
        </Button>
      </Box>
    </Paper>
  );
};

export default RoleForm;